import { Box, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { ButtonText } from '@percent/lemonade'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'
import { GivingCampaignOverviewDto } from '@percent/workplace-giving/api/campaigns/campaign.types'
import classes from './PartOfCampaignInfo.module.scss'

type PartOfCampaignInfoProps = {
  entityName: string
  campaign: GivingCampaignOverviewDto
  /**
   * If true, the link to the campaign will replace the current location in the browser history
   * (should serve as a back button)
   *
   * @default false
   */
  navigateReplace?: boolean
}

export function PartOfCampaignInfo({
  entityName,
  campaign,
  navigateReplace = false
}: Readonly<PartOfCampaignInfoProps>) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { title, id, coverImage } = campaign

  return (
    <Box className={classes.Wrapper}>
      <Box className={classes.Content}>
        <Text className={classes.Title}>
          {t('workplace_giving.campaigns.partOfCampaign.title', {
            entityName: entityName.toLocaleLowerCase(),
            campaignName: title
          })}
        </Text>
        <ButtonText
          onClick={() => {
            navigate(AppRoute.CAMPAIGN.replace(':campaignId', id), {
              replace: navigateReplace
            })
          }}
        >
          {t('workplace_giving.campaigns.partOfCampaign.goToCampaign')}
        </ButtonText>
      </Box>
      <Box className={classes.Image} style={{ backgroundImage: `url(${coverImage})` }} />
    </Box>
  )
}
